import { Tab, TabGroup, TabList } from "@headlessui/react"
import { useContext, useEffect, useLayoutEffect, useRef } from "react"
import { DisclosureContext } from "../Contexts"
import { classNames } from "../../lib"
import { focusVisibleRing } from "."
import type { BookTitle } from "../../../chuukese-books/src/books"

const Chapters = ({
  chapters,
  link,
  bookButton,
  title,
}: {
  chapters: number
  link: string
  bookButton: HTMLButtonElement | null
  title: BookTitle
}) => {
  const { setLastOpenDisclosure, lastOpenDisclosure, closeRef } = useContext(DisclosureContext)
  const lastChapter = useRef<HTMLAnchorElement>(null)

  useLayoutEffect(() => {
    if (lastOpenDisclosure != bookButton) {
      lastOpenDisclosure?.click()

      if (bookButton?.ariaExpanded) {
        setLastOpenDisclosure(bookButton)
      }

      if (closeRef.current) {
        closeRef.current(bookButton ?? undefined)
      }
    }

    if (title === "Pwärätä") {
      setTimeout(() => {
        lastChapter.current?.scrollIntoView({
          block: "end",
          behavior: "smooth",
        })
      }, 200)
    }
  }, [])

  useEffect(() => {
    if (!bookButton) return

    if (title !== "Pwärätä") {
      bookButton.scrollIntoView({
        block: "nearest",
        behavior: "smooth",
      })
    }
  }, [])

  return (
    <TabGroup
      as="div"
      manual
      onChange={index => {
        // @ts-expect-error not sure how to type this
        window.location = index === 0 ? link : `${link}#ch-${index + 1}`
      }}
    >
      <TabList className="grid grid-cols-5 px-2">
        {Array(chapters)
          .fill(null)
          .map((_, i) => (
            <Tab
              key={`chapter-${i + 1}`}
              as="a"
              href={i === 0 ? link : `${link}#ch-${i + 1}`}
              className={classNames(
                focusVisibleRing,
                "flex h-12 items-center justify-center font-normal",
                "text-center text-xl focus-visible:ring-2 focus-visible:ring-inset"
              )}
              ref={chapters === i + 1 ? lastChapter : undefined}
            >
              {i + 1}
            </Tab>
          ))}
      </TabList>
    </TabGroup>
  )
}

export default Chapters
